var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "well mt-3" }, [
    _c("div", { staticClass: "flex-level" }, [
      _c("h3", { staticClass: "mt-0" }, [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$l10n.__("%(appName)s - %(appVisibility)s", {
                appName: _vm.consumer.consumer_i_app_name,
                appVisibility: _vm.visibility
              })
            ) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "m-3 flex-row baseline flex-item-right" },
        [
          _c(
            "link-button",
            { staticClass: "mr-3", on: { clicked: _vm.deleteApp } },
            [
              _c("span", { staticClass: "red hover-alert-100" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$l10n.__("Supprimer")) +
                    "\n                "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("link-button", { on: { clicked: _vm.editApp } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$l10n.__("Modifier")) +
                "\n            "
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex-level flex-top ovy-auto" }, [
      _c("section", { staticClass: "flex flex-2" }, [
        _c("div", { staticClass: "br-1" }, [
          _c("div", { staticClass: "info info mt-2 my-1" }, [
            _c("span", { staticClass: "info-label" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$filters.capitalize(_vm.$l10n.__("consumer token"))
                  ) +
                  " :\n                    "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.consumer.consumer_token) +
                  "\n                    "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info info my-1" }, [
            _c("span", { staticClass: "info-label" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$filters.capitalize(_vm.$l10n.__("consumer secret"))
                  ) +
                  " :\n                    "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.consumer.consumer_secret))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c(
                "link-button",
                {
                  on: {
                    clicked: function($event) {
                      return _vm.regenToken(
                        "consumer",
                        _vm.consumer.consumer_id
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$filters.capitalize(
                          _vm.$l10n.__("regénérer un token consumer")
                        )
                      ) +
                      "\n                    "
                  )
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "flex flex-2 pl-3" }, [
        _c("div", { staticClass: "br-1" }, [
          _c("div", { staticClass: "info info mt-2 my-1" }, [
            _c("span", { staticClass: "info-label" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$filters.capitalize(_vm.$l10n.__("utilisateur token"))
                  ) +
                  " :\n                    "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.consumer.token_oauth_token))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info info my-1" }, [
            _c("span", { staticClass: "info-label" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$filters.capitalize(_vm.$l10n.__("utilisateur secret"))
                  ) +
                  " :\n                    "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.consumer.token_oauth_secret))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4" },
            [
              _vm.consumer.token_created_timestamp
                ? _c(
                    "link-button",
                    {
                      on: {
                        clicked: function($event) {
                          return _vm.regenToken("token", _vm.consumer.token_id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$filters.capitalize(
                              _vm.$l10n.__("regénérer un token utilisateur")
                            )
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                : _c("link-button", { on: { clicked: _vm.genToken } }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$filters.capitalize(
                            _vm.$l10n.__("générer un token utilisateur")
                          )
                        ) +
                        "\n                    "
                    )
                  ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "flex pl-3" }, [
        _c("div", [
          _c("div", { staticClass: "info info my-1 mt-2" }, [
            _c("span", { staticClass: "fs-3 gray-60 pr-1" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Niveau d'accès :")) + " ")
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _c("link-button", { on: { clicked: _vm.editVisibility } }, [
                  _vm._v(_vm._s(_vm.visibility))
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info info my-1 mt-2 flex-level" }, [
            _c("span", { staticClass: "fs-3 gray-60 pr-1" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Créateur :")) + " ")
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _c("avatar-inline", {
                  attrs: {
                    data: _vm.consumer.staff_info,
                    size: "extra-small",
                    wrapText: false
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info info my-1 mt-2" }, [
            _c("span", { staticClass: "fs-3 gray-60 pr-1" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Date de création :")) + " ")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$filters.dateFormatter(
                      _vm.consumer.created_at,
                      "NORMAL_DATE"
                    )
                  ) +
                  "\n                    "
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }